export default __webpack_public_path__ + "static/soehne-web-kraftig-kursiv-4bb18d5a6219abda76a1c8aa168ba235.eot";